Vue.asyncComponent('ak-modal-trigger', {
    data() {
        return {
            modalVisible: false,
        }
    },
    props: {
        buttonTrigger: {
            type: Object,
            required: true,
        },
        modalTitle: {
            type: String,
            required: false,
            default: ''
        },
        modalContent: {
            type: String,
            required: false,
            default: ''
        }
    },
    methods: {
        openModal() {
            this.modalVisible = true;
        },
        closeModal() {
            this.modalVisible = false;
        }
    }
}, 'layout/modal/ak-modal-trigger.html');